class JunedaysArticle extends HTMLElement {
    constructor() {
        super();
        this.initArticleContent();
    }

    // Inspects each <p> element for its contents and applies a class
    // which will be styled with CSS
    initArticleContent() {
        this.querySelectorAll('.article-content__text > p').forEach(el => {
             if (el.querySelector('img')) {
                el.classList.add('article-content__image-paragraph');
            } else if (el.querySelector('video')) {
                el.classList.add('article-content__video-paragraph');
            } else {
                el.classList.add('article-content__text-paragraph');
            }
        });
    }
}

customElements.define('junedays-article', JunedaysArticle);